<template>
  <article class="project-card" @click="handleClick">
    <div class="project-card__image-wrapper">
      <img
        v-if="project.thumbnail"
        :src="project.thumbnail"
        :alt="project.title"
        class="project-card__image"
      />
      <div v-else class="project-card__image-placeholder">
        <span>{{ project.title.charAt(0) }}</span>
      </div>
      <img
        v-if="project.logo"
        :src="project.logo"
        :alt="project.title + ' logo'"
        class="project-card__logo"
      />
      <img
        v-if="project.team"
        src="/team_icon.png"
        alt="Team project"
        title="This project was made in a team"
        class="project-card__team-icon"
      />
    </div>
    <div class="project-card__content">
      <h3 class="project-card__title">{{ project.title }}</h3>
      <p class="project-card__description">{{ project.description }}</p>
    </div>
  </article>
</template>

<script>
export default {
  name: "ProjectCard",
  props: {
    project: {
      type: Object,
      required: true,
      validator(value) {
        return value.title && value.slug && value.category;
      },
    },
  },
  emits: ["click"],
  methods: {
    handleClick() {
      this.$emit("click", this.project);
      this.$router.push({
        name: "ProjectDetail",
        params: {
          category: this.project.category,
          slug: this.project.slug,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$primary: #2563eb;
$primary-dark: #1d4ed8;
$text: #0f172a;
$text-muted: #64748b;
$border: #e2e8f0;
$card-bg: #ffffff;

.project-card {
  background-color: $card-bg;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;
  overflow: hidden;

  &:hover {
    transform: rotateX(10deg) rotateY(-4deg) scale(1.05);
  }

  &__image-wrapper {
    width: 100%;
    height: 200px;
    background-color: $border;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover &__image {
    transform: scale(1.03);
  }

  &__image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, $primary 0%, $primary-dark 100%);
    color: white;
    font-size: 3rem;
    font-weight: 700;
  }

  &__content {
    padding: 1.25rem;
  }

  &__logo {
    position: absolute;
    bottom: -50px;
    right: 30px;
    width: 100px;
    height: 100px;
    object-fit: contain;
    background-color: white;
    padding: 0.5rem;
    border-radius: 50%;
    border-top: 2px solid $border;
  }

  &__team-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 50px;
    height: 50px;
    object-fit: contain;
    border-radius: 50%;
  }

  &__image-wrapper {
    position: relative;
    border: 2px solid $border;
  }

  &__title {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
    color: $text;
    white-space: pre-wrap;
  }

  &__description {
    color: $text-muted;
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 1rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
